<ng-container *ngIf="authorization; else noAuth">
<app-toolbar [back]="back" [destination]="destination" [title]="title" [user]="user"></app-toolbar>

<div class="form" style="padding-bottom: 70px; max-width: 1300px">
  <div style="padding: 20px 30px;">
    <h3 style="text-align: center">QUESTIONARIO SULLA QUALITA’ DELLA VITA NELLE MALATTIE INFIAMMATORIE
      CRONICHE INTESTINALI (IBDQ)</h3>
    <hr>
    <h4>Istruzioni: Questo questionario è stato disegnato per capire come si è sentito nelle ultime 2 settimane.
      Le saranno poste domande sui sintomi legati alla malattia intestinale di cui soffre, su come
      si è sentito in generale, e sul suo umore.
      <br><br>
      Se ha delle difficoltà a capire la domanda, SI FERMI per un momento! Pensi a quello che la domanda significa
      per lei in relazione ai suoi problemi intestinali e cerchi poi di rispondere come meglio può.</h4>
  </div>

  <form (ngSubmit)="onSubmit()">

    <mat-card class="mat-elevation-z4" style="margin: auto; max-width: 1300px">
      <div class="container">

        <div *ngFor="let question of source">
          <label id="example-radio-group-label"><h4>{{question.position}}. {{question.question}}</h4></label>
          <mat-radio-group
            aria-labelledby="example-radio-group-label"
            class="example-radio-group">
            <mat-radio-button #button [disableRipple]="true" (click)="checkState(button, question.position)"
                              class="example-radio-button" (change)="setAnswer(button, answer, question.position)"
                              *ngFor="let answer of question.answers" [value]="answer">
              {{answer}}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>

      <div style="text-align: center; padding-top: 50px; padding-bottom: 50px;
           justify-content: center; align-content: center; align-items: center;">
        <ng-container *ngIf="submitted">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-container>

        <ng-container *ngIf="!show">
          <button  class="mat-elevation-z4" mat-raised-button type="submit" color="primary">Invia</button>
        </ng-container>
      </div>
    </mat-card>

  </form>

</div>
</ng-container>
<ng-template #noAuth>
  <app-toolbar [back]="back" [destination]="destination" [title]="'Accesso non autorizzato'" [user]="user"></app-toolbar>
  <div style="padding-bottom: 20px; padding-top: 20px; text-align: center;">
    <h4>
      L'accesso a questa pagina non è autorizzato. Torna alla home
    </h4>
    <button mat-raised-button color="warn" (click)="goHome()">Home</button>
  </div>
</ng-template>

